import { atom, createStore } from 'jotai';
import type { PrimitiveAtom } from 'jotai';
import { ManualInteractionCollectionState , ScriptPhaseEnrichmentState, SubprocessEnrichments, TechniqueEnrichments, PromptBlockingEntry, UpgradeModalTriggerState, CurrentFailedFocusGoal, CurrentFocusMicroGoalRuntime, CompletedGoalSnapshot, RuntimeConsumedAxis } from './types';
export const store = createStore();






import { 
  RaceStateRegister,
  RaceGapState,
  ElitsModule,
  SubsystemConfig,
  InterruptRule,
  AppConfig,
  StackFrame,
  ParkedFrame,
  NotebookData,
  TurnState,
  Actor,
  AnalyticsEntry,
  DeepScale,
  AudioListeningController,
SessionMemory,
LogicResponse
} from './types';
import { ELITS_MODULE_REGISTRY, SUBSYSTEMS, GLOBAL_INTERRUPTS } from './data';



// Speicherung der Prospect Emotionsanweisung je Turn

export const prospectEmotionsInstructionsAtom = atom<string | null>(null);



// Speicherung des Tokens für Quwen GPU Realtime TTS

export const qwenSimulationTokenAtom = atom<string | null>(null);



// Zur Ermittlung des irresistable Gaols fehlten noch die manuellen Vorgänge Collections

export const manualInteractionCollectionAtom =
  atom<ManualInteractionCollectionState | null>(
    null
  );



// Wir greifen direkt über register_key - moduleId::round zu
// Dadurch können wir Skripte enrichen

export const scriptPhaseEnrichmentAtom =  atom<ScriptPhaseEnrichmentState>(null);

// Wir halten die Wahrheit jetzt von allen Seiten fest

export const failedCompletedGoalSnapshotsAtom =
  atom<CompletedGoalSnapshot[]>([]);


// Enthält den State des jeweiligen Standes der Goals für Preconditions im Life Modus

export const raceStatePreconditionAtom =
  atom<RaceStateRegister>({});





// Neue Race To Gap

export const raceGapStateAtom = atom<RaceGapState>({
  currentModuleId: null,
  round: null,
  turn: null,

  possible_gap: null,
  detected_race_id_for_possible_gap: null,

  irresistable_gap: null,
  detected_race_id_for_irresistable_gap: null,

  possible_gap_matches_irresistable_gap: null,
});


// Dieses Atom sorgt dafür, dass Cues also Satzanfänge vorab geprüft und oder geblockt werden können
// so wird verhindert, dass Cues und Fragen sich dauernd wiederholen


export const promptBlockingsAtom =  atom<PromptBlockingEntry[]>([]);



// Wichtig das ist der Anfangsstand für new und pending - für den Wächter den wir brauchen beim Reset
// enthält auch das Parkdeck !!!! wichtig !!! wichtig !!!

export const watcherWorkingStateAtom =
  atom<any>(null);


// läuft um zu prüfen ob der extractor schon gelaufen ist
export const extractorRunDoneAtom = atom<boolean>(false);


// allein für manualInteraction
// Terminate Parken und manualGoalCompletion

export const possibleManualPopInteractionAtom = atom<boolean>(true);


// Dieses Atom ist für den Lifecycle normaler Techniken gedacht

type WatcherTechniqueState =
  | 'new'
  | 'pending'
  | 'selected'
  | 'parked_selected'
  | 'parked_completed'
  | 'completed'
  | 'sleep'
  | 'terminated';


type WatcherTechniqueEntry = {
  underTheStackModuleId: string;
  underTheStackRound: number;

  aboveTheStackModuleId: string;
  aboveTheStackRound: number;

  aboveTheStackCategory: string;
  aboveTheStackModulTopic: string;

  triggerIdVar: string;

  state: WatcherTechniqueState;

  firstParkedAt: number | null;
  firstParkedTurn: number | null;

  createdAt: number;
  updatedAt: number;

  reason_for_round_change?:
    | 'reset'
    | 'level_up'
    | 'smart_reset';

  prehandling_fix_detected_parent_module_id?: string | null;
  prehandling_fix_detected_parent_round?: number | null;
  prehandling_fix_detected_parent_turn?: number | null;
  objection_bridge_needed?: 'true' | 'false' | null;
  objection_detection?: 'true' | 'false' | null;
  enrichments?: TechniqueEnrichments | null;
  detectedAtTurn?: number | null;
};

export const processModulRoundStatesAtom = atom<WatcherTechniqueEntry[]>([]);

// Dieses Atom ist dafür da Subprozesse nach der neuen Logik festzuhalten

type SubprocessGoalState = {
  onStackModuleId: string;
  onStackRound: number;
  onStackFocusGoalIdIndex: number;
  onStackTriggerVariable: string;
  state: 'new' | 'pending' | 'selected' | 'parked_selected' | 'completed' | 'parked_completed' | 'handled' | 'terminated' | null;
  belowStackModuleId: string;
  belowStackRound: number;
  belowStackGoalIndex: number;
  createdAt: number;
  updatedAt: number;
  onStackCategory?: string;
  onStackModulTopic?: string;

  reason_for_round_change?:
    | 'reset'
    | 'level_up'
    | 'smart_reset';

  enrichments?: SubprocessEnrichments | null;
  detectedAtTurn?: number | null;
};

export const subprocessGoalStatesAtom = atom<SubprocessGoalState[]>([]);



// Dieses Atom ist der Gatekeeper für FeatureCaps

export const upgradeModalAtom = atom<UpgradeModalTriggerState>({
  open: false,
  scope: null,
  gateType: null,
  lockKey: null,
  lockContext: null,
});

export const upgradeModalTriggerAtom = atom<UpgradeModalTriggerState>({
  open: false,
  blocked: false,
  scope: null,
  gateType: null,
  lockKey: null,
});



// Diese Atom hält dest weshalb ein Ziel nicht erfolgreich war

export const currentFailedFocusGoalAtom =
  atom<CurrentFailedFocusGoal | null>(null);





// Dieses Atom ist dafür da den Endzustand Gesprächsausgang und Feedback festzuhalten, um ihne beim run_end zu beachten

export type RunOutcomeState =
  | 'open'
  | 'ended'
  | 'logout'
  | 'sold'
  | 'follow_up'
  | 'failed'
  | 'disqualified';
  

export type RunOutcomeAtomValue = {
  outcome: RunOutcomeState;
  run_finish_status: string | null;

  revenue: number | null;
  own_run_assessment: number | null;

  reason_for_failure?: string | null;
  reason_for_disqualification?: string | null;
  reason_for_ended?: string | null;
  reason_for_follow_up?: string | null;
  reason_for_success?: string | null;
  llm_outcome?: string | null;
  llm_response?: string | null;
  llm_revenue?: string | null;
  createdAt: number | null;
  confirmedAt?: number | null;
  feedbackSkippedAt?: number | null; 
};

export const runOutcomeAtom = atom<RunOutcomeAtomValue>({
  outcome: 'open',
  run_finish_status: 'not_finished',

  revenue: null,
  own_run_assessment: null,

  reason_for_failure: null,
  reason_for_disqualification: null,
  reason_for_ended: null,
  reason_for_follow_up: null,
  reason_for_success: null,
  llm_outcome: null,
  llm_response: null,
  llm_revenau: null,
  createdAt: null,
  confirmedAt: null,
  feedbackSkippedAt: null,
});



// Das Atom dient dafür um Events wie Klicks oder Conversions im Shop zu sammeln

export type ShopConversionSession = {
  event_name: "shop_left";
  shop_session_id: string;

  eventsource_actor_role: "tenant_admin" | "member" | "superadmin";
  for_recommendation_eventsource_member_email: string | null;
  shop_entered_at: number;
  shop_left_at: number | null;
};

export type ShopConversionEntry = {
  item_creator_short_code: string;
  item_object_key: string;
  item_object_key_immutable: string | null;
  item_type: "script" | "intervention";

  item_used_for_team: boolean;
  item_recommended_by_system: boolean;

  detail_click: number;
  add_to_cart_trial_click: number;
  add_to_cart_perm_click: number;
  trial_conversion: number;
  perm_conversion: number;
};

export const shopConversionSessionAtom =
  atom<ShopConversionSession | null>(null);

export const shopConversionEntriesAtom =
  atom<Record<string, ShopConversionEntry>>({});


// Atom das die Attempt ID am Ende erreichbar für die API Calls des COMPILERS macht

export type AssetCreationAttemptState = {
  attempt_id: string;
  asset_type: 'script' | 'intervention';
  attempt_created_at?: string | null;
  received_at_ms: number;
};

export const assetCreationAttemptAtom = atom<AssetCreationAttemptState | null>(null);

// Atom für Human in the Loop Status von Worker 1 auf Worker 8
export const compilerHumanInTheLoopAtom = atom(false);


export type CompilerWorker10FinalOutputEvent = {
  builderKind: 'script' | 'intervention';
  output: {
    worker?: string;
    version?: number;
    final_script?: {
      phase_engine_json?: Record<string, unknown>[];
      [key: string]: unknown;
    };
    trigger_json?: Record<string, unknown>;
    warnings?: unknown[];
    [key: string]: unknown;
  };
  nonce: number;
};

export const compilerWorker10FinalOutputAtom =
  atom<CompilerWorker10FinalOutputEvent | null>(null)


// Trägt das FocusGoal von Evaluator - WICHTIG ausschließlich hier
// Wird aktuell NICHT genutzt

export const currentFocusMicroGoalAtom =
  atom<CurrentFocusMicroGoalRuntime>(null);

// RunTime Speicher der Achsen

export const runtimeConsumedAxesAtom = atom<RuntimeConsumedAxis[]>([]);


// Speicherung der Snapshots der Tonalitätsauswertung 2.0

export type TonalitySnapshot = {
  hopIndex: number;
  [metricKey: string]: number | null;
};

export type TonalityChunk = {
  chunkIndex: number;
  snapshots: TonalitySnapshot[];
};

export type TonalityMergeBuffer = {
  mergeId: string;
  chunks: TonalityChunk[];
};

export const tonalitySnapshotBufferAtom = atom<TonalityMergeBuffer[]>([]);

// Speicherung des Zwischenergebnisses bei Monolop über 7 Sekunden

export const interimBubbleSimulationAtom = atom<string[]>([]);


// Tonalitäts Ring

type TonalityRingState = {
  requiredTonality: string | null;  // z.B. "enthusiastisch", "ruhig"
  achievementPercent: number | null; // 0-100
  metTonality: boolean | null;
} | null;

export const tonalityRingAtom = atom<TonalityRingState>(null);



// WICHTIG für den PROSPECT MODUS - das Ergebnis der Evaluation wird übertragen in das Atom:

export const pendingEvaluatorResultAtom = atom({});



// Wichtig für VAD im Life MODUSE  darf nur erkennen es gab ein signal und den Timestamp annehmen - mutiert keinen State mehr

export const pendingVadStartsAtom = atom<{ prospect: number | null, closer: number | null }>({
    prospect: null,
    closer: null
});


// Wichtig entspricht der currentReality es ist was immer den Stand der Realität besitzt also turn modulID round und actorRole das ist unangefochtene Realität für Life

export const currentRealityAtom = atom<{ turn: number| null, moduleId: string| null, round: number| null, actorRole: string | null }>({
    turn: 1,
    moduleId: 'default',
    round: 1,
    actorRole: null
});


// Wichtig für Analytics brauchen wir alle Goal Informationen

export const completedGoalSnapshotsAtom = atom<CompletedGoalSnapshot[]>([]);

// Neu Atom für das Halten des Pending States der Evaluator Ergebisse vor Auflösung der Promise über logic_module BEVOR die Daten an handle_stateUpdate weitergereicht werden
// Nur dann gefüllt, wenn möglicher Modulwechsel bevorstehst, ohne das das Ergebnis des Levels vorliegt
// Nur im Closer Modus ?!?

type PendingEvaluatorStateUpdate = {
  completedGoals: number[];
  memory: {
    notebook: { 
       variables: Record<string, unknown>;
    };
    meta: Record<string, unknown>;
 
  gapIds: string[];
  };
} | null;

export const pendingEvaluatorStateUpdateAtom = atom<PendingEvaluatorStateUpdate>(null);

// Neues Atom hält die Wahrheit über RESET Status - wichtig Evaluator setzt bei möglichem Wechsle auf Pending
// logic_moduel setzt auf no_reset oder reset

export type EvaluatorGateState = "reset" | "pending" | "no_reset";

export const evaluatorGateStateAtom = atom<EvaluatorGateState>("no_reset");


// Neu BOOT Atom
export type BootstrapPayload = {
  modules: any[];
  personas: any[];
  triggers: any[];
  latest_save_state: any | null;
  current_run: any | null;
  license_info: any | null;
  tenant_scret_key: any | null;
};


export const interruptCleanupAtom = atom<string[]>([]);

export const bootstrapAtom = atom<BootstrapPayload | null>(null);

export const pendingStartModuleIdAtom = atom<string | null>(null);

export const processedAnalyticsKeysAtom = atom<Set<string>>(new Set());

export const analyticsDataAtom = atom<{
  meta: Record<string, unknown> | null;
  analytics_data: Record<
    string,
    {
      analytics: Record<string, unknown> | null;
      ledger: Record<string, unknown> | null;
      variables: Record<string, unknown> | null;
    }
  >;
}>({
  meta: null,
  analytics_data: {},
});



export type SpeechTimeEvent = {
  start_speech: number | null;
  flush_at: number | null;
  actor_role: "prospect" | "closer";
  activeModuleId: string;
  round: number;
  mode: "simulation" | "life";
  merge_id?: string;
  mode_text?: boolean;
  turn?: number;
segments?: {
  segment_index: number;
  text_chunk: string;
  accumulated_text: string;
  start_speech: number;
  end_speech: number;
  duration_ms: number;
  accumulated_duration_ms: number;
}[];
 interrupted_segment_index?: number;
 barge_in_interrupted_at?: number;
};

// Ein simples Array für die fertigen Events
export const speechEventsAtom = atom<SpeechTimeEvent[]>([]);

// Ein simples Array für die fertigen Events
export const speechEventsAiAtom = atom<SpeechTimeEvent[]>([]);


// Wichtig um den Turn zu erkennen und gleichzeitige Logic Starts zu verhindern, solange der turn noch läuft
export type TurnInProgressState = {
  inProgress: boolean;
  turnedOnAt: number | null;
  turnedOffAt: number | null;
};

export const turnInProgressAtom = atom<TurnInProgressState>({
  inProgress: false,
  turnedOnAt: null,
  turnedOffAt: null,
});



// Wichtig für den Worker der die Daten des Runs verarbeitet
export const worker_register_chunks_atom = atom<Worker | null>(null);


// [NEU] Das "Heiße Draht" Atom für den Wächter
// Wenn hier Daten reinkommen, springt der Wächter in der App sofort an.
export const latestInterruptVarsAtom = atom<Record<string, any>>({});


// Atom für das Speichern vom Screenshot vom Memory vor dem RESET TIMEOUT
export const resetSnapshotAtom = atom<SessionMemory | any>({});


// Atom für das Speichern vom LogicResult vom Memory vor dem RESET TIMEOUT
export const resetLogicResultAtom = atom<LogicResponse | any>({});


// globale Reset-Version (epoch)
export const resetEpochAtom = atom(0);

// write-only action: epoch++
export const bumpResetEpochAtom = atom(null, (get, set) => {
  set(resetEpochAtom, get(resetEpochAtom) + 1);
});


// Atom für Speicherung der Daten für Analytics Worker

export const scoreLedgerAtom = atom<LedgerEntry[]>([]);
export const notebookVariablesAtom = atom<Record<string, any>>({});



export interface VisualOverrideState {
  moduleId: string;
  instanceId: number;
  ledger: [];
}

// HIER IST DER FIX:
// Wir sagen TypeScript explizit: "Das hier ist ein PrimitiveAtom, es DARF geschrieben werden."
export const visualOverrideAtom = atom<VisualOverrideState | null>(null) as PrimitiveAtom<VisualOverrideState | null>

export const isResetLockedAtom: PrimitiveAtom<boolean> = atom(false);

export const isPendingLockedAtom: PrimitiveAtom<boolean> = atom(false);


// Wichtig für die gapIds in Echtzeit

// ✅ Source: aktuelle GapIds (ändert sich dauernd) -> HIER schreibst du rein
export const gapIdsAtom = atom<string[]>([]);

// ✅ Source: completedGoals (ändert sich dauernd, async in Wellen) -> HIER schreibst du rein
export const completedGoalsAtom = atom<Record<string, boolean>>({});

// ✅ Derived: remaining = gapIds minus completedGoals -> HIER schreibst du NIE rein
export const remainingGapIdsAtom = atom<string[]>((get) => {
  const gaps = get(gapIdsAtom);
  const completed = get(completedGoalsAtom);
  return gaps.filter((id) => completed[id] !== true);
});



// löscht die Inhalte

// Action-Atom: nimmt ein Array von IDs und löscht diese Keys aus completedGoalsAtom
export const removeCompletedGoalsAtom = atom(
  null,
  (get, set, idsToRemove: string[]) => {
    const cur = get(completedGoalsAtom);
    const next = { ...cur };

    for (const id of idsToRemove) {
      delete next[id];
    }

    set(completedGoalsAtom, next);
  }
);

// Reset Goals Atom

export const resetCompletedGoalsAtom = atom(
  null,
  (_get, set) => {
    set(completedGoalsAtom, {});
  }
);


// Reset Gaps Atom

export const resetGapIdsAtom = atom(
  null,
  (_get, set) => {
    set(gapIdsAtom, []);
  }
);

// Löscht die GapIds

export const removeGapIdsAtom = atom(
  null,
  (get, set, idsToRemove: string[]) => {
    const cur = get(gapIdsAtom);
    const next = cur.filter((id) => !idsToRemove.includes(id));
    set(gapIdsAtom, next);
  }
);

// configAtom
export const configAtom = atom<Record<string, any>>({});




//export const sortedGapIdsAtom = atom((get) => {
//  const gapIds = get(remainingGapIdsAtom);
//  const config = get(configAtom);
//
//  const processStates = get(processModulRoundStatesAtom);
//
//  const underTheStackModuleIds = new Set(
//    (processStates || [])
//      .filter(entry => entry.state === 'selected')
//      .map(entry => entry.underTheStackModuleId)
//      .filter(Boolean)
//  );

//  const sorted = Array.from(new Set(gapIds));

//  const getDepth = (modId: string) => {

    // Aktuell UNDER THE STACK:
    // eigene Sortierklasse hinter normalen Sondermodulen.
    //if (underTheStackModuleIds.has(modId)) {
    //  return 1000;
    //}

    //let curr = config?.startModuleId || 'ot_module__mt_script__NEK_4622';

    //if (modId === curr) return 0;

    //for (let i = 0; i < 100; i++) {
      //const def = ELITS_MODULE_REGISTRY[curr];

      //if (!def || !def.nextModule || def.nextModule.length === 0) break;

      //curr = def.nextModule[0];

      //if (curr === modId) return i + 1;
    //}

    //return 999;
  //};

  //sorted.sort((a, b) => {
    //const partsA = a.split(':');
    //const partsB = b.split(':');

    //const modA = partsA[1];
    //const modB = partsB[1];

    //const idxA = parseInt(partsA[2] ?? '0', 10);
    //const idxB = parseInt(partsB[2] ?? '0', 10);

    //const depthA = getDepth(modA);
    //const depthB = getDepth(modB);

    //if (depthA !== depthB) return depthA - depthB;
    //return idxA - idxB;
  //});

  //return sorted;
//});


export const sortedGapIdsAtom = atom((get) => {
  const gapIds = get(remainingGapIdsAtom);
  const config = get(configAtom);

  const processStates = get(processModulRoundStatesAtom);

  const underTheStackModuleIds = new Set(
    (processStates || [])
      .filter(entry => entry.state === 'selected')
      .map(entry => entry.underTheStackModuleId)
      .filter(Boolean)
  );

  const sorted = Array.from(new Set(gapIds));

  // Modulgruppen in der bereits vorhandenen Reihenfolge merken.
  // Dadurch werden Goals verschiedener Module nicht mehr
  // über ihren goalIndex miteinander vermischt.
  const moduleOrder = new Map<string, number>();

  for (const gapId of sorted) {
    const parts = gapId.split(':');
    const modId = parts[1];

    if (modId && !moduleOrder.has(modId)) {
      moduleOrder.set(modId, moduleOrder.size);
    }
  }

  const getDepth = (modId: string) => {

    // Aktuell UNDER THE STACK:
    // eigene Sortierklasse hinter normalen Sondermodulen.
    if (underTheStackModuleIds.has(modId)) {
      return 1000;
    }

    let curr = config?.startModuleId || 'ot_module__mt_script__NEK_4622';

    if (modId === curr) return 0;

    for (let i = 0; i < 100; i++) {
      const def = ELITS_MODULE_REGISTRY[curr];

      if (!def || !def.nextModule || def.nextModule.length === 0) break;

      curr = def.nextModule[0];

      if (curr === modId) return i + 1;
    }

    return 999;
  };

  sorted.sort((a, b) => {
    const partsA = a.split(':');
    const partsB = b.split(':');

    const modA = partsA[1];
    const modB = partsB[1];

    const idxA = parseInt(partsA[2] ?? '0', 10);
    const idxB = parseInt(partsB[2] ?? '0', 10);

    const depthA = getDepth(modA);
    const depthB = getDepth(modB);

    if (depthA !== depthB) return depthA - depthB;

    // Gleiche Sortierklasse:
    // unterschiedliche Module als geschlossene Gruppen behandeln.
    if (modA !== modB) {
      return (
        (moduleOrder.get(modA) ?? 0) -
        (moduleOrder.get(modB) ?? 0)
      );
    }

    // Goal-Index ausschließlich innerhalb desselben Moduls vergleichen.
    return idxA - idxB;
  });

  return sorted;
});


// Neu dazugekommen erkennt wer gerade spricht im Life Modus:

export const activeSpeakerUIAtom = atom<string>('actor_closer');


// ==========================================================================
// 1. BibliothekAtome (Statische Definitionen aus data.ts)
// ==========================================================================

export const moduleRegistryAtom = atom<Record<string, ElitsModule>>(ELITS_MODULE_REGISTRY);
export const subsystemRegistryAtom = atom<Record<string, SubsystemConfig>>(SUBSYSTEMS);

// WICHTIG: bleibt bewusst Array, weil du data.ts dafür noch nicht umgestellt hast
export const interruptRulesAtom = atom<InterruptRule[]>(GLOBAL_INTERRUPTS);

/**
 * appConfigAtom: Absolut neutrale Initialisierung.
 * Keine Annahmen über Rollen oder Modi. Werte werden beim Setup injiziert.
 * Optional-Felder werden explizit geführt -> maximale Transparenz.
 */
export const appConfigAtom = atom<AppConfig>({
  scenario: '',
  userRole: '' as any,
  persona: '',
  leadSource: '',
  kb: '',

  customVariable: undefined,
  customVariables: undefined,
  apiKey: undefined,
  useGroq: undefined,
  useGroqForText: undefined,
  groqApiKey: undefined,
  closerName: undefined,
  prospectName: undefined,
  trainingMode: undefined,
  startModuleId: undefined,
  stopModuleId: undefined,

  executionMode: '' as any
});

// ==========================================================================
// 2. ZustandsAtome (Runtime State - Mutable)
// ==========================================================================

export const executionStackAtom = atom<StackFrame[]>([]);
export const executionParkedAtom = atom<ParkedFrame[]>([]);

export const notebookAtom = atom<NotebookData>({
  CURRENT: {
    summary: '',
    income: null,
    independence_level: '',
    emotions: [],
    scene_examples: [],
    job_role: '',
    hours_per_week: null,
    stress_level: null,
    satisfaction_level: null,
    tried_solutions: [],
    why_it_didnt_work: [],
    keywords: [],
    original_quotes: []
  },
  GOAL: {
    summary: '',
    income_target: null,
    lifestyle: [],
    identity: '',
    time_horizon_months: null,
    desired_work_style: [],
    freedom_markers: [],
    success_criteria: [],
    non_negotiables: [],
    emotional_goals: [],
    vision_scenes: [],
    wish_verbatim: undefined,
    future_self_description: undefined
  },
  GAP: {
    core_pain: '',
    monthly_gap: null,
    duration_months: null,
    loss_estimated_total: null,
    emotional_cost: [],
    if_nothing_changes: { financial: [], emotional: [], relational: [] },
    if_change_works: { financial: [], emotional: [], relational: [] },
    obstacles: [],
    limiting_beliefs: [],
    urgency_level: null,
    reason_for_urgency: '',
    problems: [],
    beliefs_detailed: undefined
  },
  MOTIVATION: {
    primary_drivers: [],
    triggers: [],
    role_models: [],
    deepest_fear_if_fail: '',
    primary_need: undefined,
    human_needs: undefined
  },
  MONEY: {
    budget_available_now: null,
    financing_options: [],
    money_mindset: []
  },
  DECISION: {
    decision_maker: '',
    other_influencers: [],
    decision_style: '',
    timeframe_to_decide_days: null,
    stated_decision_criteria: []
  },
  OBJECTIONS: {
    raised: [],
    hidden_suspected: [],
    handled: []
  },
  COMMITMENT: {
    change_readiness_score: null,
    statements_for_change: [],
    next_step_agreed: null
  },
  ATTEMPTS: { attempts: [] },
  VERBATIM: { entries: [] },
  variables: {}
});

export const turnStateAtom = atom<TurnState>({
  phase: 'output',
  updatedAt: 0
});

export const actorsAtom = atom<Record<string, Actor>>({});
export const activeActorIdAtom = atom<string>('');

export const analyticsAtom = atom<Record<string, AnalyticsEntry>>({});
export const activeTrackingKeyAtom = atom<string>('');

/**
 * moduleStateAtom: Nur Keys verwenden, die bereits in SessionMemory existieren.
 * (currentDeepness / currentGoalReasons / manual_goal_overrides)
 */
export const moduleStateAtom = atom<{
  currentDeepness: DeepScale;
  currentGoalReasons: Record<string, string>;
  manual_goal_overrides: Record<string, boolean>;
}>({
  currentDeepness: {
    clarity: 0,
    emotion: 0,
    scene: 0,
    meaning: 0,
    magnitude: 0,
    consequence: 0
  } as DeepScale,
  currentGoalReasons: {},
  manual_goal_overrides: {}
});

/**
 * audioControllerAtom: Runtime-Zustand (Timer/Marker/Error) -> State-Atom
 * Optional-Felder explizit gesetzt -> vollständiger Runtime-Shape.
 */
export const audioControllerAtom = atom<AudioListeningController>({
  phase: 'off',

  // Wer soll gerade sprechen?
  activeActorId: '',

  // Welche Quellen werden parallel überwacht?
  monitoredSourceIds: [],

  // Welche Quellen zählen als Stimme welches Actors?
  sourcesByActorId: {},

  // Polling / Reaktionszeit
  pollIntervalMs: 50,

  // Timing
  armWindowMs: 15000,
  silenceStopMs: 1000,

  // VAD
  vadEnabled: false,
  thresholdBySourceId: {},

  // Runtime Marker (optional -> explizit)
  armedAt: undefined,
  voiceStartedAt: undefined,
  lastVoiceAt: undefined,
  lastVoiceSourceId: undefined,
  lastVoiceActorId: undefined,

  lastEndReason: undefined,
  error: undefined,

  // neue Zustands-Steuerung
  armedState: 'IDLE',
  watchdogTimerMs: 0,
  bargeInCursor: undefined
});

/**
 * sessionMetadataAtom: UI-/Debug-/Runtime-Hilfszustände (nicht Core-Truth).
 * Keys bleiben exakt wie bei dir.
 */
export const sessionMetadataAtom = atom({
  history: [] as any[],
  debugStatus: '',
  logs: [] as string[],
  isAudioOn: false,
  ghostMode: false,
  aiHint: '',
  isHintLoading: false,
  inputValue: ''
});

// ==========================================================================
// 3. DerivedAtome (Computed Selectors)
// ==========================================================================

export const activeModuleSelector = atom((get) => {
  const stack = get(executionStackAtom);
  const registry = get(moduleRegistryAtom);

  if (stack.length === 0) return null;

  const top = stack[stack.length - 1];
  return registry[top.moduleId] || null;
});

export const currentMicroGoalSelector = atom((get) => {
  const stack = get(executionStackAtom);
  const activeModule = get(activeModuleSelector);

  if (!activeModule || stack.length === 0) return null;

  const top = stack[stack.length - 1];
  return activeModule.microGoals[top.stepIndex] || null;
});

export const speechShareAtom = atom((get) => {
  const analytics = get(analyticsAtom);

  let closerWords = 0;
  let prospectWords = 0;

 // Object.values(analytics).forEach((entry) => {
//    closerWords += entry.words.closer || 0;
//    prospectWords += entry.words.prospect || 0;
//  });

  const total = closerWords + prospectWords;

  return {
    ratio: total === 0 ? 0 : closerWords / total,
    closer: closerWords,
    prospect: prospectWords
  };
});

export const aiHintAtom = atom((get) => get(sessionMetadataAtom).aiHint);
export const deepnessIndicatorAtom = atom((get) => get(moduleStateAtom).currentDeepness);

// ==========================================================================
// 4. EventAtome (Write-Only Signals)
// ==========================================================================

export const processTurnEventAtom = atom(
  null,
  (_get, _set, _payload: { text: string; source: string }) => {
    // Vom Orchestrator gesteuert (Action-only)
  }
);

export const audioInterruptEventAtom = atom(null, (_get, _set) => {
  // Not-Stopp Signal (Action-only)
});

export const interruptEventAtom = atom(null, (_get, _set, _ruleId: string) => {
  // Intervention Signal (Action-only)
});
